import React from 'react';
import css from './css.module.less';

import { useDispatch } from 'react-redux';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { OriSelect } from '@/src/components/Antd';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { useI18n } from 'src/hooks/useRouterChange';
import { generateMegaMenuStyle } from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/common';
import {
  EnumCollapseId,
  getAnimationList,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getMegaMenuStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onMegaMenuStyleChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/slice';
import { store } from 'src/store';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
const Option = OriSelect.Option;

const MegaMenuStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { backgroundColor, textAndIconColor, dividerColor, priceColor } =
    data || {};
  const entranceAnimationUuid = get(data, 'entranceAnimationUuid', null);
  const animationList = useSelector(getAnimationList()) || [];
  const _animationList = [{ name: 'None', uuid: null }, ...animationList];
  //console.log(_animationList);
  const _d = useDispatch();
  const handleOnBkgChange = (e) => {
    _d(onMegaMenuStyleChange({ backgroundColor: e }));
  };
  const handleOnTextChange = (e) => {
    _d(onMegaMenuStyleChange({ textAndIconColor: e }));
  };
  const handleOnDividerChange = (e) => {
    _d(onMegaMenuStyleChange({ dividerColor: e }));
  };
  const handleOnPriceColorChange = (e) => {
    _d(onMegaMenuStyleChange({ priceColor: e }));
  };
  const handleOnAnimationChange = (e) => {
    _d(onMegaMenuStyleChange({ entranceAnimationUuid: e }));
  };

  return (
    <React.Fragment>
      <Section bottomBorder size='small' className={css.fieldSection}>
        <ItemWrapper title={getI18n('general.backgroundColour')} size='small'>
          <ColorPicker
            multi
            onChange={handleOnBkgChange}
            color={backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.textIconColour')}
          size='small'>
          <ColorPicker
            multi
            onChange={handleOnTextChange}
            color={textAndIconColor}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.dividerColour')}
          size='small'>
          <ColorPicker
            multi
            onChange={handleOnDividerChange}
            color={dividerColor}
          />
        </ItemWrapper>
        {/* <div style={{ display: 'none' }}> */}
        {/* UXPSA-7082 */}
        <ItemWrapper
          title={getI18n('salesChannelContent.index.priceColour')}
          size='small'>
          <ColorPicker
            multi
            onChange={handleOnPriceColorChange}
            color={priceColor}
          />
        </ItemWrapper>
        {/* </div> */}
      </Section>
      <Section size='small' className={css.fieldSection2}>
        <ItemWrapper title={getI18n('general.entranceAnimation')} size='small'>
          <OriSelect
            size='large'
            value={entranceAnimationUuid}
            onChange={handleOnAnimationChange}>
            {_animationList.map((i, index) => {
              const _index = index.toString();
              const { name, uuid } = i;
              return (
                <Option key={uuid || _index} value={uuid}>
                  {name}
                </Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(MegaMenuStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.megaMenuStyle,
  getContent: getMegaMenuStyle,
  title: getI18nFromGeneral('general.hOCTitle.megaMenuStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  getSubmitStamp,

  headerProps: {
    //className: css.test,
    dotsFunction: [
      {
        onClick: () => {
          const dD = generateMegaMenuStyle();
          store.dispatch(onMegaMenuStyleChange(dD));
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
